<template>
  <div id="insights" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img src="../assets/images/navbar/ic_insights.webp" class="icon-pages" />
        <span class="page-title">{{ $t("page.insights") }}</span>
        <span class="page-des page-des-line">{{
          $t("page.insights_description")
        }}</span>
      </div>

      <el-tabs
        class="style-bar"
        v-model="activeName"
        @tab-click="forceRerender"
      >
        <el-tab-pane :name="anchor.dashboard">
          <span slot="label" class="title-bar">{{ $t("page.dashboard") }}</span>
          <dashboard
            :tabActive="activeName"
            @changedTab="onChangedTab"
          ></dashboard>
        </el-tab-pane>
        <el-tab-pane :name="anchor.teams">
          <span slot="label" class="title-bar">{{ $t("page.teams") }}</span>
          <teams
            v-if="renderComponent == false && activeName == 'teams'"
          ></teams>
        </el-tab-pane>
        <el-tab-pane
          :name="anchor.cohorts"
          v-if="user && user.user_type !== 'leadership'"
        >
          <span slot="label" class="title-bar">{{ $t("page.cohorts") }}</span>
          <cohorts
            v-if="renderComponent == false && activeName == 'cohorts'"
          ></cohorts>
        </el-tab-pane>
        <el-tab-pane :name="anchor.managers">
          <span slot="label" class="title-bar">{{ $t("page.managers") }}</span>
          <managers2
            v-if="renderComponent == false && activeName == 'managers'"
          ></managers2>
        </el-tab-pane>
        <el-tab-pane :name="anchor.people">
          <span slot="label" class="title-bar">{{ $t("page.people") }}</span>
          <people v-if="renderComponent == false && activeName == 'people'"></people>
        </el-tab-pane>
        <el-tab-pane :name="anchor.relationships">
          <span slot="label" class="title-bar">Relationships</span>
          <relationships v-if="renderComponent == false && activeName == 'relationships'"></relationships>
        </el-tab-pane>
        <el-tab-pane :name="anchor.report">
          <span slot="label" class="title-bar">{{
            $t("page.reportCard")
          }}</span>
          <report
            v-if="renderComponent == false && activeName == 'report'"
          ></report>
        </el-tab-pane>
      </el-tabs>
      <component
        v-if="
          (activeName == 'teams' ||
            activeName == 'report' ||
            activeName == 'managers') &&
          renderComponent
        "
        v-bind:is="activeName"
      ></component>
    </div>
  </div>
</template>

<script>
export default {
  name: "insights",
  components: {
    dashboard: require("./insights/dashboard").default,
    teams: require("./insights/teams").default,
    cohorts: require("./insights/cohorts").default,
    managers2: require("./insights/managers").default,
    people: require("./insights/people").default,
    relationships: require("./insights/relationships").default,
    report: require("./insights/report").default,
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    dimension() {
      return this.$store.getters["insights/dimension"];
    },
    loadpage() {
      return this.$store.getters["people/loadpage"];
    },
  },
  watch: {
    activeName() {
      if (this.activeName != "") {
        this.forceRerender();
        const tab = this.activeName || "";
        const paramsTab = this.$router.currentRoute.params.tab;
        if(tab=='dashboard'){
          this.$store.dispatch("dashboard/getManager",this.user);
        }
        if (paramsTab != tab) {
          this.$router.push({ name: "insightsWithTab", params: { tab } });
        }
      }
    },
  },
  data() {
    return {
      activeName: "dashboard",
      anchor: {
        dashboard: "dashboard",
        teams: "teams",
        cohorts: "cohorts",
        managers: "managers",
        people: "people",
        report: "report",
        relationships: "relationships",
      },
      renderComponent: true,
    };
  },
  mounted() {
    const params = this.$router.currentRoute.params.tab;
    if (this.$route.query.welcome == "true") {
      this.$router.push({
        name: "insightsWithTab",
        params: { tab: "dashboard" },
        query: { welcome: "false" },
      });
    }
    if (params && this.anchor[params] && !this.$route.query.welcome) {
      this.activeName = params;
    } else if (!this.$route.query.welcome) {
      this.$router.push({
        name: "insightsWithTab",
        params: { tab: "dashboard" },
      });
    }
    this.scroll();
    this.$root.$on('changeTab', (item) => {
      if (item.path == "insights") {
        this.onChangedTab(item);
      }
    });
  },
  methods: {
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop +
            document.documentElement.clientHeight >=
          document.documentElement.scrollHeight;
        if (bottomOfWindow) {
          if (this.loadpage) {
            if (this.activeName == "people") {
              this.nextMember();
            }
          }
        }
      };
    },
    forceRerender() {
      let activeTab = this.activeName;
      if (
        (activeTab == "teams" ||
          activeTab == "report" ||
          activeTab == "managers" ||
          activeTab == "cohorts" ||
          activeTab == "people" ||
          activeTab == "relationships") &&
        this.renderComponent == true
      ) {
        this.renderComponent = false;
      } else if (activeTab == "dashboard") {
        this.$store.dispatch("insightsManagers/getDataAll");
      }
    },
    getImgUrl(pic) {
      var images = require.context(
        "../assets/images/spotlight/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    nextMember() {
      this.$store.dispatch("people/nextMember");
    },
    onChangedTab(value) {
      this.activeName = value.tab;
    },
  },
};
</script>
<style scoped></style>
<style>
#insights .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 132px;
  text-align: center;
}
#insights .el-tabs__header {
  margin: 0px;
}
</style>